import React, { useContext } from 'react';
import { useCookies } from 'react-cookie';
import CookieConsent from 'react-cookie-consent';
import DomainData from '../../assets/datasets/DomainData';
import { TrackingContext } from '../context/Tracking';
import { WindowManagerContext } from '../context/WindowManager';

const allCookies = DomainData.cookies;

const CookieConsentFelixMedicus = props => {
  const { openWindow } = useContext(WindowManagerContext);
  const { setAcceptedCookies } = useContext(TrackingContext);

  return (
    <CookieConsent
      location='bottom'
      buttonText='Erlauben'
      declineButtonText='Einstellen'
      enableDeclineButton
      onDecline={() => {
        openWindow('chooseCookie', { onClose: () => { setAcceptedCookies(allCookies.map(c => c.id)); } });
      }}
      onAccept={() => {
        setAcceptedCookies(allCookies.map(c => c.id));
      }}
      style={{ background: '#2B373B', zIndex: 3000 }}
      declineButtonStyle={{ borderRadius: 6, background: 'blue', color: 'white' }}
      buttonStyle={{ color: 'black', background: '#FFDA18', borderRadius: 6 }}
      expires={150}
      debug={process.env.NODE_ENV === 'development'}
    >
      Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern.{' '}
    </CookieConsent>
  );
};

export default CookieConsentFelixMedicus;
